export const SPRITE_SIZE = 16
export const MAP_HEIGHT = SPRITE_SIZE * 15
export const MAP_WIDTH = SPRITE_SIZE * 20
export const BE_URL = 'https://team-big-bosses-be.herokuapp.com/'
export const token = localStorage.getItem("token")